<template>
  <v-row class="pt-0" align="start">
    <v-col cols="12">
      <v-banner icon="mdi-credit-card-outline">
        Add Card for future payments
        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
      <PaymentCard :isEditingCard="false" />
    </v-col>
  </v-row>
</template>

<script>
import PaymentCard from "@/components/payment/PaymentCardForm.vue";

export default {
  name: "AddNewCard",
  components: {
    PaymentCard,
  },
  methods: {
    goToAccountPage() {
      this.$router.push({ name: "UserAccount" });
    },
  },
};
</script>